'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extensionTable = require('./extension-table.directive');

var _extensionTable2 = _interopRequireDefault(_extensionTable);

var _extensionFormHttp = require('./extensions-forms/extension-form-http.directive');

var _extensionFormHttp2 = _interopRequireDefault(_extensionFormHttp);

var _extensionFormMqtt = require('./extensions-forms/extension-form-mqtt.directive');

var _extensionFormMqtt2 = _interopRequireDefault(_extensionFormMqtt);

var _extensionFormOpc = require('./extensions-forms/extension-form-opc.directive');

var _extensionFormOpc2 = _interopRequireDefault(_extensionFormOpc);

var _extensionFormModbus = require('./extensions-forms/extension-form-modbus.directive');

var _extensionFormModbus2 = _interopRequireDefault(_extensionFormModbus);

var _extensionDialog = require('./extension-dialog.controller');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.extension', []).directive('tbExtensionTable', _extensionTable2.default).directive('tbExtensionFormHttp', _extensionFormHttp2.default).directive('tbExtensionFormMqtt', _extensionFormMqtt2.default).directive('tbExtensionFormOpc', _extensionFormOpc2.default).directive('tbExtensionFormModbus', _extensionFormModbus2.default).directive('parseToNull', _extensionDialog.ParseToNull).name;


// WEBPACK FOOTER //
// ./src/app/extension/index.js